<template>
  <BreadCrumb PageTitle="List View" />
  <ListView />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import ListView from "../../template-components/SupportDesk/ListView/ListView.vue";

export default defineComponent({
  name: "ListViewPage",
  components: {
    BreadCrumb,
    ListView,
  },
});
</script>